export default {
  OPERACION_INSTITUCION: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
